import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { SapService } from "./sap.lib.service";
import { Injectable, inject } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { EMPTY, Observable, catchError, filter, of, switchMap, take, tap } from "rxjs";
import { ShippingCostsLoaded, selectShippingCosts } from "libs/anamnese/src/lib";
import { SapShippingCostItem, SapAddress } from "../models/sap.model";
import { selectShippingAddresses } from "libs/customer/src/lib/store/customer.selectors";
import { AppState } from "libs/tm-common/src/lib/store/reducers/reducers";
import { NotificationService } from "libs/tm-common/src/lib/services/notification.lib.service";

@Injectable({
	providedIn: 'root'
})
export class ShippingCostResolver {
	private sapService = inject(SapService);
	private store = inject<Store<AppState>>(Store);
	private notificationService = inject(NotificationService);

	resolve(
		_route: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	): Observable<SapShippingCostItem[]> {
		return this.store.pipe(
			select(selectShippingCosts),
			take(1),
			switchMap((shippingCosts: SapShippingCostItem[]) => {
				//check if shippingCosts are already available in the redux store
				if (shippingCosts.length > 0) {
					return of(shippingCosts);
				}
				//shippingCosts needs to be fetched from SAP and saved in redux store
				return this.store.pipe(
					select(selectShippingAddresses),
					filter((shippingAddresses: SapAddress[]) => shippingAddresses.length > 0),
					switchMap((shippingAddresses: SapAddress[]) => {
						//XXX Note: It is not specified, what happens if a customer has shipping addresses from
						//different countries. So for now, we expect that all addresses are from the same country.
						const countryCodeShippingAddress = shippingAddresses.find(
							(item: SapAddress) => item.isBillingAddress === false
						)?.Country;
						return this.sapService.getShippingCosts(countryCodeShippingAddress).pipe(
							take(1),
							tap((shippingCosts: SapShippingCostItem[]) =>
								this.store.dispatch(
									new ShippingCostsLoaded({ shippingCosts: shippingCosts })
								)
							)
						);
					})
				);
			}),
			catchError(() => {
				this.notificationService.showErrorMessage(
					"ResolveOrderDataError",
					"Error loading shipping costs",
					5000
				);
				return EMPTY;
			})
		);
	}
}
